const TIME_FORMAT = { KO: 'kr-KO', EN: 'en-US' };
export default TIME_FORMAT;
